import React from 'react';
import styled from 'styled-components';

import { ButtonTs } from '@lt/components';
import { StarsAndBox } from '@lt/components/icons-react';
import { useTranslation } from '@lt/localization';

import type { IArchivePackageBanner } from './types';

const ArchivePackageBanner = (props: IArchivePackageBanner): JSX.Element => {
  const { isMobile = false, hotelName, hotelUrl } = props;
  const { t } = useTranslation();

  return (
    <StyledContainer $isMobile={isMobile}>
      <StyledContent $isMobile={isMobile}>
        <StarsAndBox width={196} height={114} />
        <StyledHeading $isMobile={isMobile}>
          {t('checkout.archivedPackage.title')}
        </StyledHeading>
        <StyledText $isMobile={isMobile}>
          {t('checkout.archivedPackage.relevantOffers')}{' '}
          <strong>{hotelName}</strong>
        </StyledText>
      </StyledContent>
      <StyledButton
        variant="primary"
        $isMobile={isMobile}
        onClick={() => {
          window.location.href = hotelUrl;
        }}
      >
        {t('checkout.archivedPackage.relevantOffersButton')}
      </StyledButton>
    </StyledContainer>
  );
};

const StyledContainer = styled.div<{ $isMobile?: boolean }>`
  min-width: ${({ $isMobile }) => (!$isMobile ? '940px' : '312px')};
  padding: 12px 9px 26px;
  margin: 16px ${({ $isMobile }) => (!$isMobile ? '9px' : '4px')};
  text-align: center;
  color: #17181a;
`;

const StyledContent = styled.div<{ $isMobile?: boolean }>`
  max-width: ${({ $isMobile }) => (!$isMobile ? '459px' : '280px')};
  margin: 0 auto ${({ $isMobile }) => (!$isMobile ? '24px' : '16px')};
  padding: 0px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const StyledHeading = styled.h2<{ $isMobile?: boolean }>`
  margin-bottom: 8px;
  margin-top: ${({ $isMobile }) => ($isMobile ? '7.6px' : '0')};
  font-size: ${({ $isMobile }) => (!$isMobile ? '28px' : '18px')};
  line-height: ${({ $isMobile }) => (!$isMobile ? '34px' : '22px')};
`;

const StyledText = styled.p<{ $isMobile?: boolean }>`
  font-size: ${({ $isMobile }) => (!$isMobile ? '16px' : '14px')};
  line-height: ${({ $isMobile }) => (!$isMobile ? '20px' : '16px')};
`;

const StyledButton = styled(ButtonTs)<{ $isMobile?: boolean }>`
  width: ${({ $isMobile }) => (!$isMobile ? '286px' : '291px')};
  height: ${({ $isMobile }) => (!$isMobile ? '38px' : '46px')};
  padding: 4px 8px 6px;
  font-size: 14px;
`;

export default ArchivePackageBanner;
